import CompanyInfoEditDialog from './CompanyInfoEditContainer';

export default CompanyInfoEditDialog;
